<mm-account-info-header
[accountInfo]="accountInfo"
(refresh)="refresh($event)"
></mm-account-info-header>
<mm-master-transaction-table [ngClass]="(createRequestStep$ | async) === 'view-msv' ? 'hide-table' : ''"></mm-master-transaction-table>

